import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';

// add that seperator between all elements
const addSeparator = separator => (acc, cv, i, arr) => {
  // Clone the breadcrumb so we can add a react key
  const breadcrumb = /*#__PURE__*/React.cloneElement(cv, {
    key: `breadcrumb${i}`
  });

  // Push the breadcrumb to the array
  acc.push(breadcrumb);

  // If we aren't at the end of the array then add a separator
  if (i < arr.length - 1) {
    acc.push(/*#__PURE__*/React.cloneElement(separator, {
      key: `separator${i}`
    }));
  }

  // Return the finished elements array
  return acc;
};
const defaultRenderer = (crumb, i, arr) => {
  const crumbClassName = clsx('padding-right-2 text-size-200', {
    'text-subdued-lightest': i < arr.length - 1,
    'text-link text-gray-base': i = arr.length - 1
  });
  return /*#__PURE__*/_jsx("span", {
    className: crumbClassName
  }, void 0, crumb);
};

// render a default seperator if none is provided
const defaultSeparator = /*#__PURE__*/_jsx(Glyphicon, {
  glyph: "menu-right",
  className: "padding-right-2 text-primary text-gray text-size-200"
});

/**
 * HTMl Breadcrumbs based on schema.org markup/Filters
 */
function Breadcrumbs(_ref) {
  let {
    className,
    separator = defaultSeparator,
    items = [],
    render = defaultRenderer,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), items.map(render).reduce(addSeparator(separator), []), children);
}
export default Breadcrumbs;